import { PeopleAltOutlined } from "@mui/icons-material";
import { MenuItemType } from "./type";

export enum MenuItemKey {
  ALL = "all",
  DEPARTMENT = "department",
  GROUP = "group",
  DEACTIVATE = "deactivate",
  ACCOUNTDELETE = "accountdelete",
}

export const defaultMenuItems: MenuItemType[] = [
  {
    key: MenuItemKey.ALL,
    icon: <PeopleAltOutlined />,
    label: "Tất cả",
  },
  {
    key: MenuItemKey.DEPARTMENT,
    icon: <PeopleAltOutlined />,
    label: "Phòng ban",
    children: [],
  },
  {
    key: MenuItemKey.GROUP,
    icon: <PeopleAltOutlined />,
    label: "Group",
    children: [],
  },
  {
    key: MenuItemKey.DEACTIVATE,
    icon: <PeopleAltOutlined />,
    label: "Đã nghỉ",
  },
  {
    key: MenuItemKey.ACCOUNTDELETE,
    icon: <PeopleAltOutlined />,
    label: "Tài khoản bị xóa",
  },
];
